import {Component} from "react";
import "./assets/separator.css"

class Separator extends Component{

    render() {
        return (
            <div className={"separator"}/>
        )
    }
}

export default Separator
